import React from 'react';
import Header from './layout/Header';
import Footer from './layout/Footer';
import { GlobalStyle } from '../includes/style';

type LayoutProps = {
  children: React.ReactNode
};
export default function Layout({ children }:LayoutProps){
  return <>
    <GlobalStyle />
    <a className="skip-to-content" href="#content">Skip to main content</a> {/* For A11y */}
    <Header />
    <main id="content">{children}</main>
    <Footer />
  </>;
}
